export const location = require('./location.svg');
export const payment = require('./payment.svg');
export const heart = require('./heart.svg');
export const settings = require('./settings.svg');
export const orders = require('./orders.svg');